import React from 'react';
import Spinner from 'react-spinners/FadeLoader';
import { Field } from 'redux-form';

import CheckboxGroup from '../../lib/CheckboxGroupOld';
import { CustomBooleanInput, CustomSelect } from '../../lib/CustomReduxFormComponent';
import MessagePopup from '../../lib/MessagePopupOld';
import tr from '../../lib/tr';
import breadcrumb from '../../part/breadcrumb';
import footer from '../../part/footerOld';
import nav from '../../part/navOld';
import styles from './dataselector.scss';

export default class DataSelector extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount(props) {
    this.props.loadPageData();
  }

  tr(en, ja) {
    return tr(en, ja, this.props.lang);
  }

  handleSelectChange = () => {
    this.props.updateVariables();
    this.props.updateTemporalRange();
  }

  selects(name, items, className) {
    if (items.length < 1) {
      return (
        <div>-</div>
      );
    }

    const _className = className == null ? styles.control : className;

    return (
      <Field name={name} component={CustomSelect} className={_className} onChangeCustom={this.handleSelectChange}>
        {items.map(e => {return (
          <option key={e.id} value={e.id}>{e.name}</option>
        );})}
      </Field>
    );
  }

  ensembles() {
    if (this.props.ensembles.length < 1) {
      return (
        <div>-</div>
      );
    }

    if (this.props.config['multi_ensembles']) {
      this.props.updateEnsemble2();

      const ensemble1Index = this.props.ensembles.map(e => e.id).indexOf(this.props[this.props.formValueLabel].ensemble);
      const trailingEnsembles = this.props.ensembles.filter((e, i) => i >= ensemble1Index);

      return (
        <React.Fragment>
          {this.selects('ensemble', this.props.ensembles, styles.control50)}
          {this.selects('ensemble2', trailingEnsembles, styles.control50)}
        </React.Fragment>
      );
    } else {
      return this.selects('ensemble', this.props.ensembles);
    }
  }

  itemBoxes(name, items, handleChangeAdditional=null) {
    if (items.length < 1) {
      return (
        <div>-</div>
      );
    }

    return (
      <div className={styles.experiments}>
        {items.map((e, i) => {return ([
          <Field
            defaultChecked={i===0}
            key={`input_${e.id}`}
            name={name}
            component={CustomBooleanInput}
            type="radio"
            value={e.id}
            id={`${name}-${e.id}`}
            onChangeCustom={(...arg) => {
              this.handleSelectChange();
              handleChangeAdditional && handleChangeAdditional(...arg);
            }}
          />,
          <label key={`label_${e.id}`} htmlFor={`${name}-${e.id}`}>{e.name}</label>
        ]);})}
      </div>
    );
  }

  experiments() {
    return this.itemBoxes('experiment', this.props.experiments);
  }

  frequencies(handleChangeAdditional=null) {
    return this.itemBoxes('frequency', this.props.frequencies, handleChangeAdditional);
  }

  variables() {
    const { availableVariables } = this.props;
    if (availableVariables == null) {
      return undefined;
    }
    const variables = this.props.variables.map(e => Object.assign({disabled: !availableVariables.includes(e.id)}, e));
    return (
      <Field name="variables" component={CheckboxGroup} options={variables} className={styles.variables} onChangeCustom={this.props.updateTemporalRange} />
    );
  }

  buttons() {
    return (
      <div className={styles.buttons}>
        <input type="submit" value={this.props.submitName} className={styles.primaryButton} />
      </div>
    );
  }

  form() {
    const formStyle = this.props.formStyle != null ? this.props.formStyle : styles.basicForm;

    return (
      <form onSubmit={this.props.handleSubmit}>
        <div className={formStyle}>
          <div className={styles.model}>
            <div>1. {this.tr('Select dataset [longName/shortName (calendar)]', 'データセット [名称/略称 (カレンダー)]')}</div>
            {this.selects('model', this.props.models)}
          </div>
          <div className={styles.ensemble}>
            <div>2. {this.tr('Select ensemble run', 'アンサンブル')}</div>
            {this.ensembles()}
          </div>
          <div className={styles.experiment}>
            <div>3. {this.tr('Select scenario', 'シナリオ')}</div>
            {this.experiments()}
          </div>
          <div className={styles.frequency}>
            <div>4. {this.tr('Select temporal resolution', '時間解像度')}</div>
            {this.frequencies(this.props.handleFrequencyChange)}
          </div>
          <div className={styles.variable}>
            <div>5. {this.tr('Select variables', '変数')}</div>
            {this.variables()}
          </div>
          {this.props.additionalForm}
        </div>

        {this.props.advancedForm}
        {this.buttons()}
      </form>
    );
  }

  render() {
    const { user, urls } = this.props;
    if (this.props.user == null) {
      // App is not initiated.
      return null;
    }

    const popupProps = this.props.popupProps ? this.props.popupProps() : {message: this.props.message};

    return (
      <div className={styles.root}>
        {nav(user, urls.logout, {lang: this.props.lang, setLang: this.props.updateLang})}
        <div className={styles.container}>
          {breadcrumb(urls, this.props.appLabel, this.props.lang)}
          <div className={styles.title}>{this.props.title} -{this.props.databaseLabel}-</div>
          {this.form()}
        </div>
        <MessagePopup
          {...popupProps}
          toggleMessage={this.props.toggleMessage}
        />
        <div className={styles.spinner}>
          <Spinner color="#ccc" loading={this.props.loading} />
        </div>
        <div className={styles.spinnerBackground} style={this.props.loading ? undefined : {display: 'none'}}>
        </div>
        {footer()}
      </div>
    );
  }
}
